module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pub1.jpg"
    }
  })])])]), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pocket Books"), _c('br'), _vm._v("A Division of Simon & Schuster, Inc."), _c('br'), _vm._v("1230 Avenue of the Americas"), _c('br'), _vm._v("New York, NY 10020"), _c('br'), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.SimonandSchuster.com",
      "target": "_blank"
    }
  }, [_vm._v("www.SimonandSchuster.com")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("This book is a work of fiction. Names, characters, places, and incidents either are products of the author’s imagination or are used fictitiously. Any resemblance to actual events or locales or persons, living or dead, is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Copyright © 2011 by Karen Hawkins")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever. For information address Pocket Books Subsidiary Rights Department, 1230 Avenue of the Americas, New York, NY 10020.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First Pocket Books paperback edition June 2011")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("POCKET BOOKS and colophon are registered trademarks of Simon & Schuster, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The Simon & Schuster Speakers Bureau can bring authors to your live event. For more information or to book an event contact the Simon & Schuster Speakers Bureau at 1-866-248-3049 or visit our website at "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.simonspeakers.com",
      "target": "_blank"
    }
  }, [_vm._v("www.simonspeakers.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Cover illustration by Craig White. Hand lettering by Ron Zinn.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Manufactured in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("10    9    8    7    6    5    4    3    2    1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN 978-1-4391-7593-4"), _c('br'), _vm._v("ISBN 978-1-4391-7601-6 (ebook)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-662c7b76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 72
// module chunks = 0